// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--ubO5n","offers":"_7a3fb80146--offers--EMRck","relevance":"_7a3fb80146--relevance--dYrE3"};